module.exports = __webpack_public_path__ + "img/9791186490624.f65e742b.jpg";